import React from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import { UiButton } from '../ui/ui-button';

export const MessagePageWithLogin = () => {
  const { loginWithRedirect } = useAuth0();
  return (
    <div className="u-margin-0Auto u-padding-xl u-textAlign-center">
      <h1 className="u-margin-y-xl">You have been logged out.</h1>
      <UiButton onClick={() => loginWithRedirect()}>Login</UiButton>
    </div>
  );
};
